import React from 'react';
import useOnlineStatus from './useOnlineStatus';

/** Shown across the app while offline. Money actions are disabled meanwhile. */
export default function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div role="status" className="sticky top-0 z-50 bg-amber-100 border-b border-amber-300 text-amber-900 text-sm text-center px-4 py-2">
      You're offline. Balances, rates and transfers need a connection — reconnect to continue.
    </div>
  );
}
